// extracted by mini-css-extract-plugin
export default {"DownloadCard":"DownloadCard_DownloadCard__296Ie","DownloadLink":"DownloadCard_DownloadLink__E0AW7","DownloadIcon":"DownloadCard_DownloadIcon__Duipz"};